import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IPaginationStatusProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePaginationContext
} from "../../context";
import {
    getControlMeasures
} from "../../../../helpers/theme/control";
import {
    formatNumber
} from "../../../../helpers/locale/format";
import Text from "../../../text";

const PaginationStatus: FC<IPaginationStatusProps> = ({
    customTheme: customThemeProp,
    style,
    title
}) => {
    const context = usePaginationContext();

    const customTheme = customThemeProp ?? context.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const measures = getControlMeasures({
        size: context.size,
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes
    });

    const pageText = formatNumber({
        locale: activeLocale,
        value: context.page
    });

    const totalText = context.pageCount === undefined ? "" : ` / ${formatNumber({
        value: context.pageCount,
        locale: activeLocale
    })}`;

    return <View
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-live="polite"
        role="status"
    >
        <Text
            customColor={colors.content.text.mid}
            variant={measures.valueVariant}
            customTheme={customTheme}
            style={stylesheet.text}
            numberOfLines={1}
        >
            {`${title ?? localize("pagination-page-title")} `}
            <Text
                customColor={colors.content.text.high}
                variant={measures.labelVariant}
                customTheme={customTheme}
                style={stylesheet.text}
            >
                {pageText}
            </Text>
            {totalText}
        </Text>
    </View>;
};
export default PaginationStatus;
